import React, { Component } from "react";
import getObj from "lodash/get";
import { connect } from "react-redux";
import { Form, Input, Card, Button, Row, Col, message, Empty, Descriptions, DatePicker, Select } from "antd";
import axios from "services/axios";
import moment from "moment";
import { getValue } from "../utils";

const Option = Select.Option;
const FormItem = Form.Item;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
    md: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 16},
  },
};

class OfferingDetail extends Component {
  state = {
    driverList: [],
    loading: false
  };

  componentDidMount = async () => {
    try {
      const {
        match: { params },
      } = this.props;

      let request = await axios.get(`/car-inquiry/${params.id}`);
      let res = await axios.get(`/handover/${request.data.inquiry.bookingId}`);
      this.fetchAppraiser(request.data.inquiry.bookingId);
      console.log(res.data, "handover")
      await this.setState({
        ...request.data.inquiry,
        appraisal: request.data.appraisal,
        handover: res.data.handover,
        supervisor: request.data.supervisor
      });

    } catch (err) {
      console.log(err.message);
    }
  };

  fetchAppraiser = async id => {
    let request = await axios.get(`/user/drivers`);
    this.setState({
      driverList: request.data.drivers,
    });
  };

  selectChange = value => {
    this.setState({
      appraiserId: value,
    });
  };

  onClickSubmit() {
    const { bookingId } = this.state;
    this.setState({
      loading: true
    })
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        console.log(err);
        message.error("Failed confirmation deal");
      } else {
        axios
          .put(`/handover/${this.state.handover.id}/assign-driver`, {
            acquisitorNotes: values.acquisitorNotes,
            appraiserId: this.state.appraiserId,
            bookingId,
            collectionDate: values.collectionDate ? values.collectionDate : this.state.collectionDate,
          })
          .then(res => {
            this.setState({loading:false})
            message.success("Success Assign Driver");
            this.props.history.push("/home/internal-bidding/handover");
          })
          .catch(err => {
            this.setState({loading:false})
            message.error("Failed Confirmation Deal");
          });
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { appraisal, Booking, handover, driverList, supervisor} = this.state;
    return this.state.id ?(
      <Card>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Descriptions size="small" title="Car Information" column={1} bordered={true}>
              {[
                "carDetail[7]",
                "carDetail[3]",
                "carDetail[4]",
                "carDetail[5]",
                "carSummary[3]",
                "carDetail[10]",
                "carDetail[11]",
                "carDetail[6]", 
                "carDetail[12]", 
                "carDetail[13]"
              ].map((field, index) => {
                return getObj(appraisal, field).fieldName === "Warna Eksterior" 
                ? (
                  <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                    {getValue(appraisal.carSummary, "Kategori Warna") !== "" 
                    ? getValue(appraisal.carSummary, "Kategori Warna")
                    : getObj(appraisal, field).value}
                  </Descriptions.Item>
                )
                : (
                  <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                    {getObj(appraisal, field).value}
                  </Descriptions.Item>
                )
              }
              )}
            </Descriptions>
          </Col>
          <Col xs={24} md={12}>
            <Descriptions size="small" title="Sales Informartion" column={1} bordered={true}>
              <Descriptions.Item label="Nama Sales">  {getObj(Booking, "SalesProfile.name")} </Descriptions.Item>
              <Descriptions.Item label="Nama Cabang"> {getObj(Booking, "SalesProfile.branch")} </Descriptions.Item>
              <Descriptions.Item label="No. Hp"> {getObj(Booking, "SalesProfile.phone")} </Descriptions.Item>
              <Descriptions.Item label="Nama SS"> {supervisor ? supervisor.name : ""} </Descriptions.Item>
            </Descriptions>

            <Descriptions size="small" title="Customer Information" column={1} bordered={true} style={{marginTop: 10}}>
              {["carDetail[0]", "carDetail[2]", "carDetail[1]"].map((field, index) => (
                <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                  {getObj(appraisal, field).value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Col>
        </Row>

        <Row>
          <Card title="Handover Form" style={{ marginTop: "30px" }}>
            <Form layout="vertical"  onSubmit={e => this.handleSubmit(e)}>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <FormItem label="Lokasi Penyimpanan Mobil" {...formItemLayout}>
                    {getFieldDecorator("branchOffice", {
                      initialValue: this.state.branchOffice || "",
                    })(<Input disabled />)}
                  </FormItem>

                  <FormItem label="Pilih Driver" {...formItemLayout}>
                  {getFieldDecorator("appraiser", {
                    initialValue: this.state.handover ? this.state.handover.appraiserId : "",
                  })(
                    <Select
                      showSearch
                      placeholder="Select a person"
                      optionFilterProp="children"
                      onChange={this.selectChange}
                      style={{ width: "100%" }}
                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                      {driverList.map((appraiser, index) => {
                        return (
                          <Option key={index} value={appraiser.userId}>
                            {appraiser.name}
                          </Option>
                        );
                      })}
                    </Select>
                    )}
                  </FormItem>

                  <FormItem label="Tanggal Pengambilan" {...formItemLayout}>
                    {getFieldDecorator("collectionDate", {
                      initialValue: this.state.collectionDate
                        ? moment(this.state.collectionDate, "YYYY-MM-DDTHH:mm")
                        : moment(),
                    })(<DatePicker style={{ width: "100%" }}/>)}
                  </FormItem>

                  <FormItem label="Catatan Handover" {...formItemLayout}>
                    {getFieldDecorator("acquisitorNotes", {
                      initialValue: handover.acquisitorNotes ? handover.acquisitorNotes : "",
                    })(<Input.TextArea rows={4} />)}
                  </FormItem>
                </Col>
              </Row>

              <Row style={{ float: "right" }}>
              <Col span={24}>
                <Button key="deal" type="primary" htmlType="button" loading={this.state.loading} onClick={() => this.onClickSubmit()}>
                  Submit
                </Button>
              </Col>
            </Row>
            </Form>
          </Card>
        </Row>
      </Card>
    ) : (<Empty/>) ;
  }
}

const FormOffering = Form.create()(OfferingDetail);
const mapStateToProps = ({ Auth }) => ({ Auth });

export default connect(mapStateToProps)(FormOffering);



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/Handover/HandoverUpdate.js